import { isLoggingEnabled, shouldLogErrors } from "@/constants/flags.constant";

/**
 * Logs messages to the console if the application is in testing mode.
 *
 * This function conditionally logs messages to the console based on the `isTesting` flag.
 * If `isTesting` is true, it logs the provided arguments. This helps in outputting debug
 * information during testing without affecting production logging.
 *
 * @param {...any[]} args - The messages or data to be logged to the console.
 * @returns {void}
 */
export const log = (...args: any[]): void => {
  if (isLoggingEnabled) return console.log(...args);
};

/**
 * Logs errors to the console if the application is in testing mode.
 *
 * This function conditionally logs error messages to the console based on the `isTesting` flag.
 * If `isTesting` is true, it logs the provided arguments or a fallback error message if no arguments
 * are provided. This helps in distinguishing error handling during testing from other environments.
 *
 * @param {...any[]} args - The arguments to be logged as error messages. If no arguments are provided,
 *                          a fallback error message is logged.
 * @returns {void}
 */
export const errorLog = (...args: any[]): void => {
  if (shouldLogErrors) {
    if (args) {
      return console.error(...args);
    } else {
      return console.error(
        "Something went wrong. Please review all inputs and complete any missing fields to proceed.",
      );
    }
  }
};
